import useSWR from 'swr'
import { Spinner } from '@contentful/f36-spinner'
import * as contentful from 'contentful'
import Content from './Components/Content'
import Header from './Components/Header'
import { fetcher } from './fetcher'
import Footer from './Components/Footer'
import Meta from './Components/Meta'
import { AgeGate } from './Components/AgeGate'
import { useUser } from './hooks/useUser'

function App() {
  const { data, error } = useSWR('contentful', fetcher)
  const user = useUser()

  if (error) {
    console.log(error)
    return <div>failed to load </div>
  }
  if (!data) return (<div className='scr-center'><Spinner size='large' /></div>)

  const { entry } = data

  return (
    <main>
      {!user?.isAdult ? <AgeGate user={user}/> : <>
        <Meta meta={entry?.meta} />
        <Header {...entry?.header} />
        <Content {...entry?.content} />
        <Footer {...entry?.footer} />
      </>}
    </main>
  )
}

export default App
